<div class="d-flex flex-row justify-content-center mb-3" [attr.data-automation]="'ad-write-down-child' + '-' + index()">
  <div class="d-flex flex-column me-4 attribute-width">
    @if (index() === 0) {
      <div class="text-start mb-4">
        <strong class="fs-6 ms-1">
          <span class="text-danger ziro-forms-asterisk">*</span>
          {{ 'tkey;admin.msdialplan.management.field.write_to_ad.card.keys.label' | translate }}
        </strong>
      </div>
    }
    <ziro-text [fieldId]="'attributeName'"></ziro-text>
    @if (isLast()) {
      <ziro-button
        [dataAutomation]="'add-item-button'"
        (clicked)="addItemClicked()"
        [buttonStyle]="buttonStyles.OUTLINE_INFO"
        [buttonSize]="buttonSizes.NORMAL"
        [icon]="ziroIcons.ADD"
        [label]="'tkey;admin.msdialplan.management.field.write_to_ad.card.add_button.label'"
        class="mb-3 mt-4"
      ></ziro-button>
    }
  </div>
  <div class="d-flex flex-column me-4 attribute-width">
    @if (index() === 0) {
      <div class="text-start mb-4">
        <strong class="fs-6 ms-1">
          <span class="text-danger ziro-forms-asterisk">*</span>
          {{ 'tkey;admin.msdialplan.management.field.write_to_ad.card.values.label' | translate }}
        </strong>
      </div>
    }
    <ziro-text [fieldId]="'attributeValue'" [dynamicPreviewValue]="dynamicPreviewValue()"></ziro-text>
    <div class="pb-2 pt-1">
      <span class="me-1">
        <i [ngClass]="ziroIcons.PREVIEW + ' d-inline-block vertical-align-middle'"></i>
        <span>{{ 'tkey;site_management.site.section.preview.label' | translate }}</span>
      </span>
      @if (!!previewText) {
        <span data-automation="form-preview">{{ previewText }}</span>
      }
    </div>
  </div>

  <div class="d-flex flex-column w-auto">
    @if (index() === 0) {
      <div class="text-start mb-4" style="visibility: hidden">
        <!-- Placeholder to match the height of the headers in the other columns -->
        <strong class="fs-6 ms-1">&nbsp;</strong>
      </div>
    }
    <div class="d-flex flex-row justify-content-start">
      <ziro-checkbox-button-field [fieldId]="'show'" class="me-4"></ziro-checkbox-button-field>
      @if (!hideClear()) {
        <ziro-button
          [dataAutomation]="'clear-item-button'"
          (clicked)="clearItemClicked()"
          [buttonStyle]="buttonStyles.OUTLINE_DANGER"
          [buttonSize]="buttonSizes.NORMAL"
          [icon]="ziroIcons.DELETE_SMALL"
          class="mb-3"
        ></ziro-button>
      }
    </div>
  </div>
</div>
